angular.module('dealerware.web.filters').filter('customCurrency', function() {
    return function(value, currency = 'USD') {
        const language = window.navigator.userLanguage || window.navigator.language;
        if (currency) {
            return new Intl.NumberFormat(language, { style: 'currency', currency: currency }).format(value);
        }

        return value;
    };
});